import { render, staticRenderFns } from "./quotedetails.component.vue?vue&type=template&id=929bf294&"
import script from "./quotedetails.component.vue?vue&type=script&lang=tsx&"
export * from "./quotedetails.component.vue?vue&type=script&lang=tsx&"
import style0 from "./quotedetails.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports